<template>
  <div>
    <div ref="addCustomerModal" :class="`modal confirmation-popup`" tabindex="-1" role="dialog" id="addCustomersPopup">
      <div class="modal-dialog confirmation-popup-width" role="document">
        <div class="modal-content">
          <div class="modal-header p-bottom-0 new-design">
            <h5 class="modal-title d-inline"> Add customers </h5>
            <svg class="close-icon clickable" data-dismiss="modal" aria-label="Close" width="24" height="24"
                 viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                    fill="#2E4051"/>

            </svg>
          </div>
          <div :class="{'modal-body p-top-0':true, 'p-0':isMobile}">
            <select-customers
                v-model="customer"
                :booking-customers="bookingCustomers"
                @bookingCustomersChanged="onBookingCustomersChanged"
                :can_add="canAddCustomer"
                :can_edit="canEditCustomer"
                :event="event"
                :all-object="allObject"
                :selected-customer-id="selectedCustomerId"
                view-booking-add-customers="true">
            </select-customers>
            <div id="deletePopupTeleport"></div>
          </div>
          <div :class="{'modal-footer new-design':true, 'p-top-50-important':isMobile}">
            <div class="col-md-12">
              <button type="button" data-dismiss="modal" aria-label="Close"
                      @click="cancel"
                      class="btn btn-default new-design">
                Cancel
              </button>
              <button v-if="!isLoading" type="button" @click="submitCustomer"
                      class="btn btn-primary new-design btn-confirm">
                <span> Add </span>
              </button>
              <button v-else type="button"
                      class="btn btn-primary new-design btn-confirm">
                <img src="/pic/loading-4.gif">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationPopup from "../../common/components/ConfirmationPopup.vue";
import CustomerInfo from "./CustomerInfo.vue";
import SelectCustomers from "../../common/components/SelectCustomers.vue";
import {updateBookingCustomers} from "../api";
import {EventBus} from "../../../events/event-bus";
export default {
    name: "AddCustomersPopup",
    components: {SelectCustomers, ConfirmationPopup, CustomerInfo},
    props: {
      bookingCustomers:{},
      canAddCustomer: false,
      canEditCustomer:false,
      event:null,
      selectedCustomerId:"",
      allObject:null
    },
  data() {
    return {
        customer: {
            customer_id: (this.event || {}).customer_id ?? 0,
            customer_name: (this.event || {}).customer_name ?? null,
            has_bill_payer:(this.event || {}).has_bill_payer?? 0,
            different_bill_payer:(this.event || {}).different_bill_payer === 1,
            properties: [],
        },
      bookingNewCustomers:{},
      isLoading:false,
    };
  },
  computed: {
    isMobile() {
      return this.getWidth() < 460;
    },
  },
    methods:{
      getWidth() {
        let xWidth = null;
        if (window.screen != null)
          xWidth = window.screen.availWidth;

        if (window.innerWidth != null)
          xWidth = window.innerWidth;

        if (document.body != null)
          xWidth = document.body.clientWidth;

        return xWidth;
      },
      onBookingCustomersChanged(customers){
        this.bookingNewCustomers = customers.filter(cus => cus.customer_id !=null);
      },
      submitCustomer(){
        this.isLoading = true;
          updateBookingCustomers(this.event.booking_id, JSON.stringify(this.bookingNewCustomers)).then((response) => {
            $(this.$refs['addCustomerModal']).modal('hide')
            EventBus.$emit('changeCustomer',[...response.data.newCustomers])
            EventBus.$emit('setNewCustomers', response.data.newCustomers)
            this.bookingNewCustomers = response.data.newCustomers;
            $.notify(response.data.message, response.data.type);
            this.isLoading = false;
        })
      },
      cancel(event) {
        this.$emit('on-cancel', event)
        $(this.$refs['addCustomerModal']).modal('hide')
      },
    },
}
</script>
<style scoped>
:deep(.modal-footer.new-design)
{
  display: block !important;
}
.admin_declineBookingRequest{
  z-index: 1250 !important ;
}

.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2E4051;
  display: inline;
}

.modal-footer.new-design {
  border-top: unset;
  text-align: left;
  padding-top: 0px;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.error-label {
  top: 8px;
  position: relative;
}

.btn.new-design {
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
}

.btn-primary.new-design {
  background: #2E4051 !important;
  float: right;
}

.btn-default.new-design {
  color: #2E4051
}

.form-control.new-design::placeholder {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.form-control.new-design {
  padding: 16px;
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  box-sizing: border-box;

  height: 56px;

  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.p-0{
  padding: 0px;
}

.btn.new-design {
  margin-bottom: unset;
}

@media (max-width: 768px) {
  .btn.new-design {
    width: 100%
  }

  .btn-default.new-design {
    margin-bottom: 10px;
  }
}
.confirmation-popup.in .modal-footer.new-design
{
  display: block !important;
}
.p-top-50-important{
  padding-top: 50px !important;
}
:deep(#deleteCustomerModal .confirmation-popup-width){
  width: 85% !important;
}
</style>